<div mat-dialog-title class="details-title">
  <img *ngIf="data.photo" class="details-photo" [src]="data.photo" alt="">
  <div>
    <h5>{{ data.title }}</h5>
    <div class="details-subtitle" *ngIf="data.subtitle">{{ data.subtitle }}</div>
  </div>
</div>

<mat-dialog-content>
  <dl class="details-list" *ngIf="entries.length; else noDetails">
    <ng-container *ngFor="let entry of entries">
      <dt>{{ entry.label }}</dt>
      <dd>{{ entry.value }}</dd>
    </ng-container>
  </dl>
  <ng-template #noDetails>
    <p class="no-details">No details available.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>
